import { Navigate, Route, Routes } from "react-router-dom";
import {
  EMPTY,
  HOME,
  LOGIN,
  PERMISSIONS_CONTROLCENTRE,
  PERMISSIONS_CONTROLCENTRE_ACCESSLEVEL,
  PERMISSIONS_CONTROLCENTRE_SECTIONS,
  PERMISSIONS_DATAAPI,
  PRIVATE_BASE,
  PUBLIC_BASE,
  ROLE_DETAIL,
  ROLES,
  USER_DETAIL,
  USERS,
} from "./shared/lib/routesResolver";
import PublicLayout from "./layout/public/PublicLayout";
import LoginContainer from "./components/public/login/LoginContainer";
import PrivateLayout from "./layout/private/PrivateLayout";
import HomeContainer from "./components/private/home/HomeContainer";
import PrivateRoute from "./layout/private/PrivateRoute";
import { LoadingProvider } from "./contexts/loadingContext";
import { Toaster } from "./shared/components/toast/Toaster";
import { TooltipProvider } from "./shared/components/tooltip/Tooltip";
import UsersOverview from "./components/private/user/UsersOverview";
import RolesOverview from "./components/private/role/RolesOverview";
import UserDetail from "./components/private/user/detail/UserDetail";
import DataApiPermissionsOverview from "./components/private/permission/dataapi/DataApiPermissionsOverview";
import ControlCentrePermissionsOverview from "./components/private/permission/controlcentre/ControlCentrePermissionsOverview";
import CCSectionsPermissionsOverview from "./components/private/permission/controlcentre/sections/CCSectionsPermissionsOverview";
import CCAccessLevelPermissionsOverview from "./components/private/permission/controlcentre/access-level/CCAccessLevelPermissionsOverview";
import RoleDetail from "./components/private/role/detail/RoleDetail";

const App = () => (
  <LoadingProvider>
    <TooltipProvider>
      <Toaster />
      <Routes>
        <Route path={PUBLIC_BASE} element={<PublicLayout />}>
          <Route path={PUBLIC_BASE} element={<Navigate to={LOGIN} />} />
          <Route path={LOGIN} element={<LoginContainer />} />
        </Route>
        <Route path={PRIVATE_BASE} element={<PrivateRoute />}>
          <Route path={EMPTY} element={<PrivateLayout />}>
            <Route path={EMPTY} element={<Navigate to={HOME} />} />
            <Route path={HOME} element={<HomeContainer />} />
            <Route path={USERS} element={<UsersOverview />} />
            <Route path={USER_DETAIL} element={<UserDetail />} />
            <Route path={ROLES} element={<RolesOverview />} />
            <Route path={ROLE_DETAIL} element={<RoleDetail />} />
            <Route
              path={PERMISSIONS_DATAAPI}
              element={<DataApiPermissionsOverview />}
            />
            <Route
              path={PERMISSIONS_CONTROLCENTRE}
              element={<ControlCentrePermissionsOverview />}
            />
            <Route
              path={PERMISSIONS_CONTROLCENTRE_SECTIONS}
              element={<CCSectionsPermissionsOverview />}
            />
            <Route
              path={PERMISSIONS_CONTROLCENTRE_ACCESSLEVEL}
              element={<CCAccessLevelPermissionsOverview />}
            />
          </Route>
        </Route>
      </Routes>
    </TooltipProvider>
  </LoadingProvider>
);

export default App;
